// noinspection JSUnresolvedFunction
import {BooleanBox, CheckboxItem, CheckboxValue} from "../styles"
import { FormikProvider, useFormik } from "formik";
import FormikInput from "../../../../components/FormikInput";
import MDBox from "../../../../components/MDBox";
import pxToRem from "../../../../assets/theme/functions/pxToRem";
import * as Yup from "yup";
import { memo, useEffect, useState } from "react";
import { useApi } from "../../../../services/helpers";
import { useDebouncedValidate } from "../../../../shared/formik_debounce_validate";
import AddBaseModal from "../../../../components/add-base-modal/AddBaseModal";
import { wrapApiCall } from "../../../../services/helpers_ts";
import { useApiMessages } from "../../../../services/api/api-messages";
import MDTypography from "../../../../components/MDTypography";
import {Checkbox} from "@mui/material";

const REQUIRED_FIELD_MSG = "This field is required";

Yup.addMethod(Yup.mixed, "foreignKey", function (args) {
  return this.test("test-object-id", args.message, (value) => value && value.id);
});

const validationSchema = Yup.object().shape({
  name: Yup.string().required(REQUIRED_FIELD_MSG),
  show_image: Yup.boolean().nullable(),
});

const initialValues = {
  name: "",
  show_image: false,
};

export const FilterModalForm = ({ open, item, onClose, onSave, setLoading, loading, isGroup=true }) => {
  const api = useApi();
  const [init, setInit] = useState(false);
  const messages = useApiMessages(isGroup? "group": "option", isGroup? "groups": "options");

  const formik = useFormik({
    initialValues: item ? { ...item } : initialValues,
    validateOnChange: false,
    validationSchema: validationSchema,
    onSubmit: (values) => save(values),
  });

  useDebouncedValidate({
    validate: (values) => {
      formik.validateForm(values);
    },
    debounceTime: 200,
    values: formik.values,
  });

  const save = (values) => {
    setLoading(true);
    let data = { ...values };
    if (item?.id) {
      onEdit(data);
    } else {
      onCreate(data);
    }
  };

  const onEdit = (data) => {
    if (isGroup) {
      wrapApiCall(api.updateProductGroup(item?.id, data), {
        successMessage: messages.update.success,
        onSuccess: onSave,
        errorMessage: messages.update.error,
        onError: (result) => {
          formik.setErrors(result.errors);
        },
        onFinally: () => setLoading(false),
      });
    } else {
      wrapApiCall(api.updateFeature(item?.id, data), {
        successMessage: messages.update.success,
        onSuccess: onSave,
        errorMessage: messages.update.error,
        onError: (result) => {
          formik.setErrors(result.errors);
        },
        onFinally: () => setLoading(false),
      });
    }
  };

  const onCreate = (data) => {
    if (isGroup) {
      wrapApiCall(api.createProductGroup(data), {
        successMessage: messages.create.success,
        onSuccess: onSave,
        errorMessage: messages.create.error,
        onError: (result) => {
          formik.setErrors(result.errors);
        },
        onFinally: () => setLoading(false),
      });
    } else {
      wrapApiCall(api.createFeature(data), {
        successMessage: messages.create.success,
        onSuccess: onSave,
        errorMessage: messages.create.error,
        onError: (result) => {
          formik.setErrors(result.errors);
        },
        onFinally: () => setLoading(false),
      });
    }
  };

  return (
    <AddBaseModal
      open={open}
      loading={loading}
      handleClose={() => {
        formik.resetForm();
        onClose();
      }}
      title={item?.id ? `Edit ${isGroup? "Group": "Option"}` : `Add ${isGroup? "Group": "Option"}`}
      buttonText={"Save"}
      onSubmit={formik.handleSubmit}
    >
      <MDBox
        display="flex"
        flexDirection="column"
        gap={pxToRem(22)}
        pt={pxToRem(32)}
        px={pxToRem(45)}
      >
        <FormikProvider value={formik}>
          <FormikInput name="name" label={isGroup? "Group Name" : "Option Name"} />
          {!isGroup &&
            <MDBox sx={BooleanBox}>
              {/*<Radio sx={CheckboxItem} value={false} />*/}
              <Checkbox sx={CheckboxItem}
                        checked={formik.values.show_image}
                        onChange={(e) => formik.setFieldValue('show_image', !formik.values.show_image)}
              />
              <MDTypography sx={CheckboxValue}>Show image?</MDTypography>
            </MDBox>
          }

        </FormikProvider>
      </MDBox>
    </AddBaseModal>
  );
};
